import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { CurrencySelectionModal } from './modals/CurrencySelectionModal';

export const CurrencyModalWrapper = () => {
  const { user, showCurrencyModal, setShowCurrencyModal } = useAuth();

  if (!user || !showCurrencyModal) {
    return null;
  }

  return (
    <CurrencySelectionModal
      isOpen={showCurrencyModal}
      onClose={() => {}} // Prevent closing without selection
      onSuccess={() => {
        setShowCurrencyModal(false);
      }}
    />
  );
};
